const getScriptUrls = (htmlContent) => {
  const scriptUrls = [];
  const scriptTags =
    htmlContent.match(/<script[^>]*src="([^"]*)"[^>]*>/g) || [];
  for (const tag of scriptTags) {
    const match = tag.match(/src="([^"]*)"/);
    if (
      match &&
      match[1] &&
      !match[1].includes("?") &&
      match[1].endsWith(".js")
    ) {
      scriptUrls.push(match[1].split("/").pop());
    }
  }
  return scriptUrls;
};

const getLinkUrls = (htmlContent) => {
  const linkUrls = [];
  const linkTags = htmlContent.match(/<link[^>]*href="([^"]*)"[^>]*>/g) || [];
  for (const tag of linkTags) {
    const match = tag.match(/href="([^"]*)"/);
    if (
      match &&
      match[1] &&
      !match[1].includes("?") &&
      match[1].endsWith(".css")
    ) {
      linkUrls.push(match[1].split("/").pop());
    }
  }
  return linkUrls;
};

let retryCount = 0;
let timer = null;
let oldFiles = null;

const getFilesName = async () => {
  try {
    const response = await fetch("./index.html?t=" + new Date().getTime());
    if (!response.ok) {
      throw new Error("获取 index.html 失败");
    }
    const htmlContent = await response.text();
    retryCount = 0; // 重置重试计数

    return {
      scriptsList: new Set(getScriptUrls(htmlContent)),
      linksList: new Set(getLinkUrls(htmlContent)),
    };
  } catch (error) {
    console.error("获取文件列表失败");
    if (retryCount < 3) {
      retryCount++;
      await new Promise((resolve) => setTimeout(resolve, 3000));
      return getFilesName();
    }
    throw error;
  }
};

const checkForUpdates = async () => {
  // console.log("执行文件变更比对");
  try {
    const newFiles = await getFilesName();
    if (!oldFiles) {
      oldFiles = newFiles;
      return;
    }
    const hasNewScripts = Array.from(newFiles.scriptsList).some(
      (script) => !oldFiles.scriptsList.has(script)
    );
    const hasNewStyles = Array.from(newFiles.linksList).some(
      (link) => !oldFiles.linksList.has(link)
    );
    if (hasNewScripts || hasNewStyles) {
      clearInterval(timer);

      // 如果提供了自定义更新回调，则使用它
      showUpdateTips();
    }
  } catch (error) {
    console.error("检查更新时出错");
  }
};

export const showUpdateTips = () => {
  // console.log("文件变更了需要刷新一下");
  window.location.reload();
};

export const initializeDetector = () => {
  // console.log("定时校验文件变更初始化");
  getFilesName()
    .then((files) => {
      oldFiles = files;
      timer = setInterval(checkForUpdates, 1800000); // 每30分钟检查一次
    })
    .catch(() => {
      console.error("初始化更新检测器失败");
    });
};

export const destroyDetector = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
};
